import React, { useEffect, useState } from 'react'
import { add } from '../Store/Slice';
import { useDispatch } from 'react-redux';
import Loader from './Loader';
const Product = () => {

    const[loading,setLoader]= useState(true)
 const dispatch = useDispatch()
    const [Products,setProducts]=useState([])
useEffect(()=>{
const fatchProduct= async()=>{

    try {
        const res = await fetch('https://fakestoreapi.com/products');
    const deta = await res.json();
    // console.log(deta);
    setProducts(deta);
        setLoader(false) 
      } catch (error) {
      
        setLoader(false)
      }


}
fatchProduct();
},[]); 

const handleadd= (product)=>{
dispatch(add(product))
}


  return (
    <div className='productWrrap'>  
{
loading ? <Loader/>:
    Products.map(product=>{
        return(
            <div className="Cmain">
            <div className="card" >
                  <div className="card-body" key={product.id}>
            <img src={product.image} alt={product.name} className="card-img-top"/>
            <h5 className="card-title">{product.title}</h5>
          
            <p className="card-price">${product.price}</p>
            <button onClick={()=>handleadd(product)} className="card-button">Add to Cart</button>
            </div>
        </div>
        </div>
        )
    })
}
    </div>
  )
}

export default Product